<template>
<div class="s_chat_middle_transfer" v-if="show">
  <!-- 客服转接 -->
  <ul class="s-chat-middle-transfer-list" v-show="true">
    <li class="s-transfer-item g-flex-align-center" v-for="(item,index) in transferList" :key="index" @click.stop="transferItemClick(item)">
      <span>{{item.name}}</span>
      <i class="iconfont icon-transfer"></i>
    </li>
  </ul>
  <div class="s-no-zhuanjie-box g-flex-column g-flex-align-center" v-show="!transferList.length">
    <div class="s-zhuanjie-icon">
      <SvgIcon name="zhuanjie" />
    </div>
    <p>暂无客服</p>
  </div>
</div>

</template>

<script>
  import { apiGetKefuList, apiTransferKefu } from '@/utils/api.js'

  export default {
    data() {
      return {
        show: false,
        transferList: [], //转接列表
        chatUserId: null
      }
    },
    methods: {
      async onShow(flag, userId) {
        this.chatUserId = userId
        if(!flag) return this.show = flag
        const { success, data } = await apiGetKefuList()
        if(!success) return
        this.transferList = data.list
        // console.log(data)
        this.show = flag
      },
      
      async transferItemClick(item) {
        const { success, data } = await apiTransferKefu({ id: item.id, user_id: this.chatUserId })
        if(!success) return
        this.$message.success(data.msg)
        this.onClose()
        // console.log(data)
      },

      onClose() {
        this.show = false
        this.$emit('emitTransferShow', false)
      },
    }
  }
</script>

<style lang="scss">
.s_chat_middle_transfer {
  z-index: 99999;
  position: absolute;
  background: $white;
  top: 45px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 5px;
  .s-chat-middle-transfer-list {
    .s-transfer-item {
      min-width: 80px;
      padding: 10px 5px;
      border-bottom: 1px solid $chatMsgBorderColor;
      &:nth-last-of-type(1) {
        border-bottom: none;
      }
      span {
        flex: 1;
      }
      &:hover {
        color: $mainBlue;
        span {
          color: $mainBlue;
        }
      }

    }
  }
  .s-no-zhuanjie-box {
    padding: 4px 24px;
    .s-zhuanjie-icon {
      font-size: 60px;
    }
    p {
      color: rgba(4, 15, 66, 0.7);
      font-size: $small-more-font-size;
    }
  }
}
</style>